import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { CheckedList } from '../clickCheckbox';

/**
 * 新着求人一覧 この条件で検索するボタン押下時遷移先URL生成
 *
 * @param checkedList チェックされた条件リスト
 * @returns 遷移先URL
 */
export const searchActionToJobSearchList = (checkedList: CheckedList) => () => {
  // 職種をocパラメータに変換
  const occupationParam = createParam(
    QUERY_PARAMS.oc,
    'L',
    checkedList.occupationCheckedList
  );

  // エリアをarパラメータに変換
  const areaParam = createParam(
    QUERY_PARAMS.ar,
    undefined,
    checkedList.areaCheckedList
  );

  // 業種をindパラメータに変換
  const industryParam = createParam(
    QUERY_PARAMS.ind,
    'L',
    checkedList.industryCheckedList
  );

  // 検索条件パラメータを生成
  const newJobListFlagParam = QUERY_PARAMS.op.concat('=1');
  const paramList = [
    areaParam,
    occupationParam,
    industryParam,
    newJobListFlagParam,
  ];

  const url = createUrl(paramList);
  window.location.href = url;
};

/**
 * 選択された条件をURLパラメータに変換する関数
 *
 * @param {string} paramName - パラメータ名
 * @param {string | undefined} tail - 各アイテムIDの末尾に追加する文字列（省略可能）
 * @param {string[]} checkedList - 選択されたアイテムIDのリスト
 * @returns {string} - URLパラメータ形式の文字列
 */
export const createParam = (
  paramName: string,
  tail: string | undefined,
  checkedList: string[]
) => {
  if (checkedList.length === 0) {
    return '';
  }
  const paramWithTail = tail
    ? checkedList.map((itemId) => {
        return itemId.concat(tail);
      })
    : checkedList;

  const strItemList = paramWithTail.join(',');
  const itemParam = `${paramName}=${strItemList}`;
  return itemParam;
};

/**
 * 検索結果一覧への遷移先URLを生成
 *
 * @param paramList パラメータリスト
 * @returns 検索結果一覧への遷移先URL
 */
export const createUrl = (paramList: string[]) => {
  // 職種・エリア・業種と新着フラグのパラメータを結合
  const strParams = paramList.filter((param) => param !== '').join('&');
  return DODA_SITE_URL.jobSearchList.concat('?', strParams);
};
